import { devUserEmail } from './config'

/**
 * Decouples the API client from the auth provider.
 * AuthProvider registers a token getter at startup; api/client.ts reads it.
 * The same module carries the reverse signal: a 401 from the API asks auth to
 * end the session (see setUnauthorizedHandler / notifyUnauthorized — sprint B2).
 */
let tokenGetter: (() => Promise<string | null>) | null = null
let unauthorizedHandler: (() => void) | null = null

export function setTokenGetter(fn: () => Promise<string | null>) {
  tokenGetter = fn
}

/**
 * Токен для запроса. Ошибку геттера НЕ глотаем: он бросает только когда обновление не
 * состоялось по временной причине (сеть/5xx у Keycloak), а сам токен, возможно, ещё жив.
 * Раньше такой сбой превращался в `null` → запрос уходил без `Authorization` → 401 → выход,
 * то есть моргнувшая сеть стоила сессии. Теперь запрос просто не уходит и падает с ошибкой,
 * а react-query его повторит. Мёртвый токен по-прежнему даёт `null` (после logout).
 */
export async function getAccessToken(): Promise<string | null> {
  if (!tokenGetter) return null
  return tokenGetter()
}

/**
 * AuthProvider registers what should happen when the API rejects a token (401):
 * in real-auth mode this clears the session and bounces to /login. In
 * dev-fallback there is no Bearer token, so the API never sees a stale one.
 */
export function setUnauthorizedHandler(fn: () => void) {
  unauthorizedHandler = fn
}

/** Called by api/client.ts on a 401 response. */
export function notifyUnauthorized(): void {
  unauthorizedHandler?.()
}

/** Dev-fallback identity, used only when no OIDC token is present. */
export function getDevUserEmail(): string {
  return devUserEmail
}
